import { render, staticRenderFns } from "./DimensionsSelector.vue?vue&type=template&id=40653eee&scoped=true&"
import script from "./DimensionsSelector.vue?vue&type=script&lang=js&"
export * from "./DimensionsSelector.vue?vue&type=script&lang=js&"
import style0 from "./DimensionsSelector.vue?vue&type=style&index=0&id=40653eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40653eee",
  null
  
)

export default component.exports